exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host /deep/ .layout-preview .ag-header-cell,\n:host /deep/ .layout-preview .ag-header-group-cell {\n  padding: 0 4px;\n  font-size: 11px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/grid-layout-menu/grid-layout-manage.component.scss
// module id = 2187
// module chunks = 66